import { useMutation, useQuery, useQueryClient } from 'react-query';
import { createFolder, deleteFolder, fetchFolderById, fetchFolders } from '../api/folderApi';
import { filterFoldersByScope, sortFolders } from '../utils/folders';

export function useFolderById(token, folderId) {
    return useQuery({
        queryKey: ['folder', folderId],
        queryFn: () => fetchFolderById(token, folderId),
        enabled: !!token && !!folderId,
        retry: false,
    });
}

export function useFolders(token, scope) {
    return useQuery({
        queryKey: ['folders', scope],
        queryFn: async () => {
            const folders = await fetchFolders(token);
            return filterFoldersByScope(scope, folders);
        },
        enabled: !!token,
        initialData: [],
        retry: false,
    });
}

export function useCreateFolder(token, scope) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (folderData) => createFolder(token, { ...folderData, scope }),
        onSuccess: (createdFolder) => {
            queryClient.setQueryData(['folders', scope], (currentFolders = []) => {
                const withoutDuplicate = currentFolders.filter((folder) => folder.id !== createdFolder.id);
                return sortFolders([...withoutDuplicate, createdFolder]);
            });
        },
    });
}

export function useDeleteFolder(token, scope) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (folderId) => deleteFolder(token, folderId),
        onSuccess: () => {
            queryClient.invalidateQueries(['folders', scope]);
        },
    });
}


